/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PrizeRevealMethod } from './PrizeRevealMethod';
import {
    PrizeRevealMethodFromJSON,
    PrizeRevealMethodFromJSONTyped,
    PrizeRevealMethodToJSON,
} from './PrizeRevealMethod';

/**
 * 
 * @export
 * @interface S2WGame
 */
export interface S2WGame {
    /**
     * 
     * @type {number}
     * @memberof S2WGame
     */
    wheelTextLimit: number;
    /**
     * 
     * @type {number}
     * @memberof S2WGame
     */
    promoTextLimit: number;
    /**
     * Hard limit on the number of times a single player can play this spin to win game per day. This can be
     * null/undefined if there is no limit.
     * @type {number}
     * @memberof S2WGame
     */
    dailySpinLimit?: number | null;
    /**
     * The cost in points to spin the wheel
     * @type {number}
     * @memberof S2WGame
     */
    pointCost: number;
    /**
     * 
     * @type {string}
     * @memberof S2WGame
     */
    name: string;
    /**
     * How the prize reveal is staged for this game.
     * 
     * DOUBLE_WHEEL_PRIZE_REVEAL runs a category/group stage before the prize stage
     * (today: group wheel then prize wheel). SINGLE_WHEEL_PRIZE_REVEAL skips the
     * category stage and goes straight to a single prize stage (today: prize wheel
     * only). Defaults to DOUBLE_WHEEL_PRIZE_REVEAL.
     * @type {PrizeRevealMethod}
     * @memberof S2WGame
     */
    prizeRevealMethod?: PrizeRevealMethod | null;
    /**
     * Theme to use for the game
     * @type {string}
     * @memberof S2WGame
     */
    theme: string;
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof S2WGame
     */
    customerId: string;
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof S2WGame
     */
    id: string;
}



/**
 * Check if a given object implements the S2WGame interface.
 */
export function instanceOfS2WGame(value: object): value is S2WGame {
    if (!('wheelTextLimit' in value) || value['wheelTextLimit'] === undefined) return false;
    if (!('promoTextLimit' in value) || value['promoTextLimit'] === undefined) return false;
    if (!('pointCost' in value) || value['pointCost'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('theme' in value) || value['theme'] === undefined) return false;
    if (!('customerId' in value) || value['customerId'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function S2WGameFromJSON(json: any): S2WGame {
    return S2WGameFromJSONTyped(json, false);
}

export function S2WGameFromJSONTyped(json: any, ignoreDiscriminator: boolean): S2WGame {
    if (json == null) {
        return json;
    }
    return {
        
        'wheelTextLimit': json['wheelTextLimit'],
        'promoTextLimit': json['promoTextLimit'],
        'dailySpinLimit': json['dailySpinLimit'] == null ? undefined : json['dailySpinLimit'],
        'pointCost': json['pointCost'],
        'name': json['name'],
        'prizeRevealMethod': json['prizeRevealMethod'] == null ? undefined : PrizeRevealMethodFromJSON(json['prizeRevealMethod']),
        'theme': json['theme'],
        'customerId': json['customerId'],
        'id': json['id'],
    };
}

export function S2WGameToJSON(value?: S2WGame | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'wheelTextLimit': value['wheelTextLimit'],
        'promoTextLimit': value['promoTextLimit'],
        'dailySpinLimit': value['dailySpinLimit'],
        'pointCost': value['pointCost'],
        'name': value['name'],
        'prizeRevealMethod': PrizeRevealMethodToJSON(value['prizeRevealMethod']),
        'theme': value['theme'],
        'customerId': value['customerId'],
        'id': value['id'],
    };
}

